import React from 'react'
import { Routes, Route, Link } from 'react-router-dom'
import { OrderProvider } from './context/OrderContext'
import { AuthProvider } from './context/AuthContext' // ton contexte auth global
import { PartnerAuthProvider } from './context/PartnerAuthContext'
import './footer.css'

// --- Pages client ---
import Home from './pages/Home'
import ServiceSelectionPage from './pages/ServiceSelectionPage'
import OptionsPage from './pages/OptionsPage'
import PickupPage from './pages/PickupPage'
import DeliveryPage from './pages/DeliveryPage'
import PaymentPage from './pages/PaymentPage'
import OrderConfirmationPage from './pages/OrderConfirmationPage'
import MyOrdersPage from './pages/MyOrdersPage'
import AccountPage from './pages/account/AccountPage'
import PersonalInfoPage from './pages/account/PersonalInfoPage'
import AddressPage from './pages/account/AddressPage'
import RacketSettingsPage from './pages/account/RacketSettingsPage'


// --- Pages admin existantes ---
import AdminDashboard from './pages/admin/AdminDashboard'
import AdminServicesPage from './pages/admin/AdminServicesPage'
import AdminTransportPage from './pages/admin/AdminTransportPage'
import AdminOrdersPage from './pages/admin/AdminOrdersPage'
import AdminSlotsPage from './pages/admin/AdminSlotsPage'
import AccountingDashboard from './pages/admin/accounting/AccountingDashboard'
import AdminPartnersPage from './pages/admin/AdminPartnersPage'
import AdminPartnerDetailPage from './pages/admin/AdminPartnerDetailPage'
import AdminCouponsPage from './pages/admin/AdminCouponsPage'
import AdminAccountsPage from './pages/admin/AdminAccountsPage'
import CouponViewerPage from './pages/admin/CouponViewerPage'
import RequireAdmin from './components/RequireAdmin'
import AdminLayout from './components/AdminLayout'

// --- Partner pages ---
import PartnerLoginPage from './pages/partner/PartnerLoginPage'
import PartnerDashboard from './pages/partner/PartnerDashboard'
import PartnerOverview from './pages/partner/PartnerOverview'
import PartnerOrdersPage from './pages/partner/PartnerOrdersPage'
import PartnerMembersPage from './pages/partner/PartnerMembersPage'
import PartnerSettingsPage from './pages/partner/PartnerSettingsPage'
import PartnerChangePasswordPage from './pages/partner/PartnerChangePasswordPage'
import PartnerBookPage from './pages/partner/PartnerBookPage'
import PartnerServicePage from './pages/partner/PartnerServicePage'
import PartnerOptionsPage from './pages/partner/PartnerOptionsPage'
import PartnerPaymentPage from './pages/partner/PartnerPaymentPage'
import RequirePartner from './components/RequirePartner'
import OrderStartRedirect from './components/OrderStartRedirect'

// --- Auth pages ---
import ForgotPasswordPage from './pages/login/ForgotPasswordPage'
import ResetPasswordPage from './pages/login/ResetPasswordPage'
import AuthPage from './pages/login/AuthPage'
import AdminOrderDetailPage from "./pages/admin/AdminOrderDetailPage"; // page de login/inscription côté client
import AdminFeedbacksPage from './pages/admin/AdminFeedbacksPage'
import OrderFeedbackPage from './pages/OrderFeedbackPage'
import AppHeader from "./components/AppHeader"
import EmailConfirmedPage from "./pages/login/EmailConfirmedPage"
import TunnelLayout from "./components/TunnelLayout"
import packageJson from '../package.json' assert { type: 'json' }

const App: React.FC = () => {
  const appVersion = packageJson.version
  return (
    <AuthProvider>
      <PartnerAuthProvider>
        <OrderProvider>
          <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <AppHeader />

            {/* --- Main Content --- */}
            <main style={{ flex: 1, padding: '1rem' }}>
              <Routes>
                {/* --- Tunnel client F1 --- */}
                <Route path="/" element={<Home />} />
                <Route path="/order/start" element={<TunnelLayout><OrderStartRedirect publicElement={<ServiceSelectionPage />} /></TunnelLayout>} />
                <Route path="/order/options" element={<TunnelLayout><OptionsPage /></TunnelLayout>} />
                <Route path="/order/pickup" element={<TunnelLayout><PickupPage /></TunnelLayout>} />
                <Route path="/order/delivery" element={<TunnelLayout><DeliveryPage /></TunnelLayout>} />
                <Route path="/order/payment" element={<TunnelLayout><PaymentPage /></TunnelLayout>} />
                <Route path="/order/confirmation" element={<TunnelLayout><OrderConfirmationPage /></TunnelLayout>} />
                <Route path="/orders/confirmation" element={<TunnelLayout><OrderConfirmationPage /></TunnelLayout>} />
                <Route path="/order/:id/feedback" element={<OrderFeedbackPage />} />

                {/* --- Auth client --- */}
                <Route path="/auth/login" element={<AuthPage />} />
                <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
                <Route path="/auth/email-confirmed" element={<EmailConfirmedPage />} />

                {/* --- Mon compte & commandes (F2/F3) --- */}
                <Route path="/orders" element={<MyOrdersPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/account/personal-info" element={<PersonalInfoPage />} />
                <Route path="/account/address" element={<AddressPage />} />
                <Route path="/account/racket" element={<RacketSettingsPage />} />

                {/* --- Partner Portal --- */}
                <Route path="/partner/login" element={<PartnerLoginPage />} />
                <Route
                  path="/partner"
                  element={
                    <RequirePartner>
                      <PartnerDashboard />
                    </RequirePartner>
                  }
                >
                  <Route path="dashboard" element={<PartnerOverview />} />
                  <Route path="orders" element={<PartnerOrdersPage />} />
                  <Route
                    path="members"
                    element={
                      <RequirePartner requiredRole="ADMIN_PARTNER">
                        <PartnerMembersPage />
                      </RequirePartner>
                    }
                  />
                  <Route path="settings" element={<PartnerSettingsPage />} />
                  <Route path="change-password" element={<PartnerChangePasswordPage />} />
                </Route>

                {/* --- Partner Booking Tunnel --- */}
                <Route
                  path="/partner/book"
                  element={
                    <TunnelLayout>
                      <RequirePartner>
                        <PartnerBookPage />
                      </RequirePartner>
                    </TunnelLayout>
                  }
                />
                <Route
                  path="/partner/book/service"
                  element={
                    <TunnelLayout>
                      <RequirePartner>
                        <PartnerServicePage />
                      </RequirePartner>
                    </TunnelLayout>
                  }
                />
                <Route
                  path="/partner/book/options"
                  element={
                    <TunnelLayout>
                      <RequirePartner>
                        <PartnerOptionsPage />
                      </RequirePartner>
                    </TunnelLayout>
                  }
                />
                <Route
                  path="/partner/book/payment"
                  element={
                    <TunnelLayout>
                      <RequirePartner>
                        <PartnerPaymentPage />
                      </RequirePartner>
                    </TunnelLayout>
                  }
                />

                {/* --- Backoffice --- */}
                <Route
                  path="/admin"
                  element={
                    <RequireAdmin>
                      <AdminLayout />
                    </RequireAdmin>
                  }
                >
                  <Route index element={<AdminDashboard />} />
                  <Route path="services" element={<AdminServicesPage />} />
                  <Route path="transport" element={<AdminTransportPage />} />
                  <Route path="orders" element={<AdminOrdersPage />} />
                  <Route path="orders/:id" element={<AdminOrderDetailPage />} />
                  <Route path="slots" element={<AdminSlotsPage />} />
                  <Route path="accounting" element={<AccountingDashboard />} />
                  <Route path="partners" element={<AdminPartnersPage />} />
                  <Route path="partners/:id" element={<AdminPartnerDetailPage />} />
                  <Route path="coupons" element={<AdminCouponsPage />} />
                  <Route path="coupons/:couponId/view" element={<CouponViewerPage />} />
                  <Route path="accounts" element={<AdminAccountsPage />} />
                  <Route path="feedbacks" element={<AdminFeedbacksPage />} />
                </Route>
              </Routes>
            </main>

            {/* --- Footer --- */}
            <footer className="app-footer-premium" data-testid="app-footer">
              <div className="footer-container">
                <div className="footer-content">
                  <div className="footer-brand">
                    <div className="footer-logo">StringNow</div>
                    <p className="footer-tagline">Cordage professionnel à Crissier & Lausanne</p>
                  </div>
                  
                  <div className="footer-links">
                    <Link to="/order/start" className="footer-link">Réserver</Link>
                    <Link to="/auth/login" className="footer-link">Se connecter</Link>
                    <Link to="/partner/dashboard" className="footer-link">Espace Partenaire</Link>
                    <a href="https://t.me/stringnow" target="_blank" rel="noopener noreferrer" className="footer-link">Telegram</a>
                    <a href="https://wa.me/message/LMQEI75YYCOBA1" target="_blank" rel="noopener noreferrer" className="footer-link">WhatsApp</a>
                  </div>
                  
                  <div className="footer-social">
                    <p className="footer-contact">📍 Crissier · Lausanne, Suisse</p>
                  </div>
                </div>
                
                <div className="footer-bottom">
                  <p>© 2026 StringNow · v{appVersion}</p>
                </div>
              </div>
            </footer>
          </div>
        </OrderProvider>
      </PartnerAuthProvider>
    </AuthProvider>
  )
}

export default App
